import type { QueryHookOptions } from "@apollo/client";
import { useQuery, gql } from "@apollo/client";

import type { State } from "@shared/types/graphqlGenerated";

const States_Shared_Query = gql`
  query States_Shared_Query {
    viewer {
      states {
        id
        name
        abbr
      }
    }
  }
`;

interface StatesData {
  viewer: {
    states: State[];
  };
}

const useStatesQuery = (options?: QueryHookOptions<StatesData>) => {
  return useQuery<StatesData>(States_Shared_Query, options);
};

export type { StatesData };

/* eslint-disable @fullscript/gql-no-manual-hook-declaration */
export { States_Shared_Query, useStatesQuery };
